import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { sortBy } from 'lodash';

import {
  makeStyles,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Chip,
  Typography,
  Divider,
  ListItemText,
  Checkbox,
  FormHelperText,
} from '@material-ui/core';

import EditEventDataField from '../../../../widgets/EditEventDataField';
import styles from './styles';

const useStyles = makeStyles(styles);

export const EventTemplateFormsComponent = (props) => {
  const {
    formEventData,
    handleSetFormEventData,
    eventTemplates,
    handleSelectEventTemplate,
    formEventTemplates,
    handleSetFormEventTemplates,
    disabled,
    formType,
    formEventTemplateError,
  } = props;
  const classes = useStyles();

  // local state
  const [openEventTemplateSelect, setOpenEventTemplateSelect] = useState(false);

  const handleFormEventDataChange = (newValue, eventDataIndex) => {
    const eventDataList = sortBy(formEventData.value, ['order', 'name']);
    eventDataList[eventDataIndex].value = newValue;
    handleSetFormEventData({ value: eventDataList });
  };

  const handleFormEventTemplateDataChange = (newValue, templateIndex, eventDataIndex) => {
    const eventTemplateList = formEventTemplates.value;
    eventTemplateList[templateIndex].eventData[eventDataIndex].value = newValue;
    handleSetFormEventTemplates({ value: eventTemplateList });
  };

  const inputLabel = React.useRef(null);
  return (
    <div>
      {
        sortBy(formEventData.value, ['order', 'name']).map((data, index) => (
          <EditEventDataField
            key={data.name}
            eventDataField={data}
            onChange={(value) => handleFormEventDataChange(value, index)}
            disabled={disabled}
          />
        ))
      }

      { formType !== 'Single'
      && (
        <FormControl variant="outlined" fullWidth margin="normal" error={!!formEventTemplateError}>
          <InputLabel ref={inputLabel} id="form-select-outlined-label">
            {formType === 'Select'
              ? 'Select Form'
              : 'Select All Applicable Forms' }
          </InputLabel>
          <Select
            onClick={() => { setOpenEventTemplateSelect(!openEventTemplateSelect); }}
            open={openEventTemplateSelect}
            disabled={disabled}
            multiple
            labelId="form-select-outlined-label"
            value={formEventTemplates.value}
            onChange={(e, selected) => { handleSelectEventTemplate(selected.props.value); }}
            labelWidth={formType === 'Select'
              ? 95
              : 215}
            renderValue={(selected) => (
              <div className={classes.chips}>
                {selected.map((value) => (
                  <Chip key={value.id} label={value.name} className={classes.chip} />
                ))}
              </div>
            )}
          >
            {
              eventTemplates.map((eventTemplate) => (
                <MenuItem key={eventTemplate.id} value={eventTemplate}>
                  <Checkbox color="primary" checked={formEventTemplates.value.map((fet) => fet.id).indexOf(eventTemplate.id) >= 0} />
                  <ListItemText primary={eventTemplate.name} />
                </MenuItem>
              ))
            }
          </Select>
          <FormHelperText>{formEventTemplateError}</FormHelperText>
        </FormControl>
      )}

      {
        formEventTemplates.value.map((template, templateIndex) => (
          <div key={template.id} className={classes.eventTemplateFormContainer}>
            <Typography variant="subtitle1" component="div">{template.name}</Typography>
            <Divider />
            {
              template.eventData.length === 0
                ? <Typography>No form fields</Typography>
                : template.eventData.map((data, eventDataIndex) => (
                  <EditEventDataField
                    key={data.name}
                    eventDataField={data}
                    onChange={(value) => handleFormEventTemplateDataChange(value, templateIndex, eventDataIndex)}
                    disabled={disabled}
                  />
                ))
            }
          </div>
        ))
      }
    </div>
  );
};

EventTemplateFormsComponent.propTypes = {
  formEventData: PropTypes.object,
  handleSetFormEventData: PropTypes.func,
  eventTemplates: PropTypes.array,
  handleSelectEventTemplate: PropTypes.func,
  formEventTemplates: PropTypes.object,
  handleSetFormEventTemplates: PropTypes.func,
  disabled: PropTypes.bool,
  formType: PropTypes.any,
  formEventTemplateError: PropTypes.string,
};
EventTemplateFormsComponent.defaultProps = {
  formEventData: { value: [] },
  handleSetFormEventData: () => {},
  eventTemplates: [],
  handleSelectEventTemplate: () => {},
  formEventTemplates: { value: [] },
  handleSetFormEventTemplates: () => {},
  disabled: false,
  formType: 'Single',
  formEventTemplateError: null,
};

export default EventTemplateFormsComponent;
